<template>
  <right-panel :datas="itemForm" :items="itemForm" @onClose="onCloseForm" @onSubmit="onSubmitAddForm" ref="right-panel-add">
    <div slot="header">
      <translate>Add Log Filter</translate>
    </div>
  </right-panel>
</template>

<script>
  import STORE_CONST from '../../../store/consts'
  import RightPanel from '../../common/right-panel'
  export default{
    name: 'ClusterLogFilter',
    props: {
      items: {
        required: true
      }
    },
    data () {
      return {
        itemForm: null
      }
    },
    methods: {
      // 确定添加
      onSubmitAddForm () {
        let params = {
          data: {
            network_id: Number(this.$route.params.id),
            operator: 'contains',
            condition: this.$refs['right-panel-add'].profileModel.condition.trim()
          }
        }
        this.$store.dispatch(STORE_CONST.CLUSTER.ADD_LOG_FILTER, params).then(() => {
          this.$notify({
            message: this.$gettext('Add Successfully!'),
            type: 'success'
          })
          this.$emit('callback')
        })
        setTimeout(() => {
          this.onCloseForm()
        }, 300)
      },
      // 关闭添加成员
      onCloseForm () {
        this.itemForm = null
        this.$emit('onClosePanel')
      }
    },
    watch: {
      'items': {
        handler: function (newVal) {
          if (this.itemForm) {
            this.itemForm = null
            setTimeout(() => {
              this.itemForm = this.items
            }, 300)
          } else {
            this.itemForm = this.items
          }
        },
        deep: true
      }
    },
    components: {
      RightPanel
    }
  }
</script>

<style lang='scss' rel="stylesheet/scss">

</style>



// WEBPACK FOOTER //
// cluster-log-filter.vue?78eec3ed